export default __webpack_public_path__ + "static/thomas-4d2cd697f9626035ce5fb3255a7b835f.png";